import BaseServiceHttp from '../baseService'
class UploadVideo extends BaseServiceHttp {
  constructor(id) {
    const resource = 'postagens/upload'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new UploadVideo(id)
